import React from 'react';

const SkillPracticeGrid = () => {
  const cards = [
    {
      icon: 'menu_book',
      tag: 'Mới',
      tagColor: 'blue',
      title: 'Một Ngày Ở Trường',
      description: 'Đọc về các hoạt động hàng ngày và trả lời câu hỏi về các môn học.',
      time: 15,
      xp: 150
    },
    {
      icon: 'edit',
      tag: null,
      tagColor: 'orange',
      title: 'Hoàn Thành Câu Chuyện',
      description: 'Nhìn vào tranh và viết các câu còn thiếu để hoàn thành câu chuyện.',
      time: 20,
      xp: 200
    },
    {
      icon: 'library_books',
      tag: null,
      tagColor: 'purple',
      title: 'Ở Thư Viện',
      description: 'Học từ vựng về sách và các quy tắc đọc sách trong thư viện.',
      time: 10,
      xp: 100
    },
    {
      icon: 'pets',
      tag: null,
      tagColor: 'blue',
      title: 'Động Vật & Môi Trường Sống',
      description: 'Đọc mô tả về các loài động vật và ghép chúng với nơi chúng sinh sống.',
      time: 12,
      xp: 120
    },
    {
      icon: 'mail',
      tag: 'Khó',
      tagColor: 'orange',
      title: 'Viết Bưu Thiếp',
      description: 'Hãy tưởng tượng bạn đang đi nghỉ. Viết một tấm bưu thiếp cho người bạn thân.',
      time: 25,
      xp: 250
    },
    {
      icon: 'history_edu',
      tag: null,
      tagColor: 'purple',
      title: 'Động Từ Thì Quá Khứ',
      description: 'Điền vào chỗ trống bằng dạng đúng của động từ.',
      time: 18,
      xp: 180
    }
  ];

  const cardColorClasses = {
    blue: {
      bg: 'bg-blue-50 dark:bg-blue-900/20',
      text: 'text-primary-blue',
      tagBg: 'bg-blue-50 dark:bg-blue-900/20',
      tagText: 'text-blue-600 dark:text-blue-400',
      hoverBorder: 'hover:border-blue-100 dark:hover:border-blue-900',
      hoverShadow: 'hover:shadow-[0_8px_30px_rgba(60,131,246,0.1)]'
    },
    orange: {
      bg: 'bg-orange-50 dark:bg-orange-900/20',
      text: 'text-accent-orange',
      tagBg: 'bg-orange-50 dark:bg-orange-900/20',
      tagText: 'text-orange-600 dark:text-orange-400',
      hoverBorder: 'hover:border-orange-100 dark:hover:border-orange-900',
      hoverShadow: 'hover:shadow-[0_8px_30px_rgba(249,115,22,0.1)]'
    },
    purple: {
      bg: 'bg-purple-50 dark:bg-purple-900/20',
      text: 'text-accent-purple',
      tagBg: 'bg-purple-50 dark:bg-purple-900/20',
      tagText: 'text-purple-600 dark:text-purple-400',
      hoverBorder: 'hover:border-purple-100 dark:hover:border-purple-900',
      hoverShadow: 'hover:shadow-[0_8px_30px_rgba(139,92,246,0.1)]'
    }
  };

  return (
    <div className="mx-auto max-w-6xl">
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3">
        {cards.map((card, index) => {
          const colors = cardColorClasses[card.tagColor] || cardColorClasses.blue;
          return (
            <div key={index} className={`group flex flex-col gap-4 rounded-2xl border border-transparent bg-card-light dark:bg-card-dark p-6 shadow-[0_4px_20px_rgba(0,0,0,0.03)] transition-all hover:-translate-y-1 ${colors.hoverBorder} ${colors.hoverShadow}`}>
              <div className="flex items-start justify-between">
                <div className={`flex size-14 items-center justify-center rounded-2xl ${colors.bg} ${colors.text}`}>
                  <span className="material-symbols-outlined text-[32px]">{card.icon}</span>
                </div>
                {card.tag && (
                  <span className={`rounded-full px-2.5 py-1 text-xs font-bold ${colors.tagBg} ${colors.tagText}`}>
                    {card.tag}
                  </span>
                )}
              </div>
              <div className="flex flex-col gap-1">
                <h3 className="text-lg font-bold text-slate-900 dark:text-white">{card.title}</h3>
                <p className="text-sm leading-relaxed text-slate-500 dark:text-slate-400 line-clamp-2">{card.description}</p>
              </div>
              <div className="mt-2 flex items-center gap-2 text-xs font-semibold text-slate-500 dark:text-slate-400">
                <span className="material-symbols-outlined text-base">timer</span>
                <span>{card.time} mins</span>
                <span className="mx-1 h-1 w-1 rounded-full bg-slate-300 dark:bg-slate-700"></span>
                <span>{card.xp} XP</span>
              </div>
              <button className="mt-2 flex w-full items-center justify-center rounded-xl bg-primary-blue py-3 text-sm font-bold text-white shadow-sm transition-transform hover:scale-[1.02] active:scale-[0.98]">
                Luyện tập
              </button>
            </div>
          );
        })}
      </div>
      {/* Bottom CTA Area */}
      <div className="mt-12 mb-8 flex justify-center">
        <div className="flex flex-col items-center gap-4 text-center">
          <p className="text-slate-500 dark:text-slate-400 font-medium">Muốn thử bài khác?</p>
          <button className="flex items-center gap-2 px-6 py-3 rounded-xl border-primary-blue/20 bg-card-light dark:bg-card-dark text-primary-blue font-bold hover:bg-primary-blue-blue/5 transition-colors">
            <span className="material-symbols-outlined">shuffle</span>
            Bài tập ngẫu nhiên
          </button>
        </div>
      </div>
    </div>
  );
}

export default SkillPracticeGrid;
